import Swiper from "swiper";
import { Mousewheel, Navigation, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";

class AssociationsSlider {
  constructor(el) {
    this.el = el;
    this.swiper = this.el.querySelector(".swiper");

    if (this.swiper) {
      new Swiper(this.swiper, {
        autoHeight: false,
        slidesPerView: 1.25,
        loop: false,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        direction: "horizontal",
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },

        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
        },
        pagination: {
          el: this.el.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            const number = (index + 1).toString().padStart(2, '0');
            return `<button type="button" class="${className}">${number}</button>`;
          }
        },
        navigation: {
          prevEl: this.el.querySelector(".swiper-arrows .swiper-arrows__prev"),
          nextEl: this.el.querySelector(".swiper-arrows .swiper-arrows__next"),
        },
        on: {
          slideChange: function () {
            const isEnd = this.isEnd;
            const container = this.el;
      
            if (isEnd) {
              container.classList.add('is-end');
            } else {
              container.classList.remove('is-end');
            }
          }
        },

        modules: [Pagination, Navigation, Mousewheel],
      });
    }
  }
}

function initAssociationsSliders() {
  const sliders = document.querySelectorAll(".js-associations");
  for (let slider of sliders) {
    new AssociationsSlider(slider);
  }
}

initAssociationsSliders();
